import React from 'react';
interface InfoItemProps {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}
export function InfoItem({
  label,
  value,
  mono
}: InfoItemProps) {
  return <div className="min-w-0" data-id="element-125" data-mp="5cm34um4d7zt">
      <dt className="text-xs text-muted-foreground" data-id="element-126" data-mp="9c4pzvxi3t5a">{label}</dt>
      <dd className={`mt-0.5 break-words text-sm font-medium text-navy-900 ${mono ? 'font-mono tracking-tight' : ''}`} data-id="element-127" data-mp="9ajxscynsmal">{value}</dd>
    </div>;
}